import { Col, Form, Row } from "react-bootstrap"
import { AdditionalOptionsType } from "./AdditionalOptions"

export enum ForcePrimaryClinic {
  NOT_SELECTED = '',
  IF_AVAILABLE = '1',
  ONLY = '2'
}

export interface ForcePrimaryClinicOptionsProps {
  selected?: string
  onUpdate: (optionType: AdditionalOptionsType, value: string) => void
}

const ForcePrimaryClinicOptions = (props: ForcePrimaryClinicOptionsProps) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onUpdate(AdditionalOptionsType.FORCE_PRIMARY_CLINIC, e.target.checked
      ? e.target.value
      : ForcePrimaryClinic.NOT_SELECTED
    )
  }

  return (
    <>
      <Row>
        <Col>
          <div className="h5">Primary Clinics</div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Check inline id="force-if-available" type="checkbox" className="with-label"
            label="Display Primary Clinics First"
            value={ForcePrimaryClinic.IF_AVAILABLE}
            checked={props.selected === ForcePrimaryClinic.IF_AVAILABLE}
            onChange={onChange} />
          <Form.Text className="ml-4 d-block">Only Primary clinics will be displayed; otherwise the full list of clinics that were found will be displayed.</Form.Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Check inline id="force-only" type="checkbox" className="with-label"
              label="Display Primary Clinics Only"
              value={ForcePrimaryClinic.ONLY}
              checked={props.selected === ForcePrimaryClinic.ONLY}
              onChange={onChange} />
            <Form.Text className="ml-4 d-block">Only the Primary clinics will be displayed.</Form.Text>
        </Col>
      </Row>
    </>
  )
}

export default ForcePrimaryClinicOptions
